
import { isLocationInList as googleMapsTest } from '../Geolocation/GoogleMaps-wrapper';
import { isLocationInList as maxmindTest } from '../Geolocation/Maxmind-wrapper';

export default async function isLocationInList( locationsList) {
  try {
    return await googleMapsTest( locationsList);
  } catch( error) {
    try {
      return await maxmindTest( locationsList);
    } catch( error) {
      const newError = { message: 'Error intentando determinar la geolocalizacion.', baseError: error };
      throw newError;
    }
  }
}
